import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

const isProduction = process.env.NODE_ENV === "production";

async function getSummary(clientId) {
  return handleResponse(await fetch(`${baseUrl}clientledger/summary?clientId=${encodeURIComponent(clientId)}`, { headers: authHeaders() }));
}

function buildLedgerEntryQuery(entry) {
  if (!entry.clientId || !entry.entryKey) {
    throw new Error("clientledger production writes require clientId and entryKey.");
  }

  return `?clientId=${encodeURIComponent(entry.clientId)}&entryKey=${encodeURIComponent(entry.entryKey)}`;
}

async function getClientLedger(clientId = "", schoolYearStartYear) {
  const query = clientId ? `?clientId=${encodeURIComponent(clientId)}${schoolYearStartYear === undefined ? '' : `&schoolYearStartYear=${schoolYearStartYear}`}` : "";
  const response = await fetch(`${baseUrl}clientledger/${query}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function saveClientLedgerEntry(entry, isNew = false) {
  const expectedRevision = entry.expectedRevision === undefined ? (await getSummary(entry.clientId)).revision : entry.expectedRevision;
  const resourcePath = isProduction
    ? `clientledger/${!isNew && entry.id ? buildLedgerEntryQuery(entry) : ""}`
    : `clientledger/${encodeURIComponent(!isNew && entry.id ? entry.id : "")}`;

  const response = await fetch(`${baseUrl}${resourcePath}`, {
    method: !isNew && entry.id ? "PUT" : "POST",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify({ ...entry, expectedRevision }),
  });
  return handleResponse(response);
}

async function deleteClientLedgerEntry(entry) {
  const expectedRevision = entry.expectedRevision === undefined ? (await getSummary(entry.clientId)).revision : entry.expectedRevision;
  const resourcePath = isProduction
    ? `clientledger/${buildLedgerEntryQuery(entry)}`
    : `clientledger/${encodeURIComponent(entry.id)}`;

  const response = await fetch(`${baseUrl}${resourcePath}${resourcePath.includes('?') ? '&' : '?'}expectedRevision=${expectedRevision}`, {
    method: "DELETE",
    headers: authHeaders({ "content-type": "application/json" }),
  });
  return handleResponse(response);
}

async function command(path, input) {
  return handleResponse(await fetch(`${baseUrl}clientledger/${path}`, {
    method: 'POST', headers: authHeaders({ 'content-type': 'application/json' }), body: JSON.stringify(input),
  }));
}

const previewSettlement = input => command('settlements/preview', input);
const approveSettlement = input => command('settlements/approve', input);
const mutateSettlementFees = input => command('settlements/fees', input);
async function getSettlementFees({ clientId, month, schoolYearStartYear }) {
  const query = `clientId=${encodeURIComponent(clientId)}&month=${encodeURIComponent(month)}&schoolYearStartYear=${schoolYearStartYear}`;
  return handleResponse(await fetch(`${baseUrl}clientledger/settlements/fees?${query}`, { headers: authHeaders() }));
}

const transfer = input => command('transfers', input);
const reverseTransfer = (operationId, input) => command(`transfers/${encodeURIComponent(operationId)}/reverse`, input);
const previewAssignments = clientId => command('year-assignments/preview', { clientId });
const applyAssignments = input => command('year-assignments/apply', input);
const rollbackAssignments = input => command('year-assignments/rollback', input);
async function getAssignmentStatus(operationId, clientId) {
  return handleResponse(await fetch(`${baseUrl}clientledger/year-assignments/${encodeURIComponent(operationId)}?clientId=${encodeURIComponent(clientId)}`, { headers: authHeaders() }));
}

export default { previewSettlement,
  getSettlementFees,
  mutateSettlementFees,
  approveSettlement,
  getClientLedger,
  saveClientLedgerEntry,
  deleteClientLedgerEntry,
  getSummary,
  transfer,
  reverseTransfer,
  previewAssignments,
  applyAssignments,
  rollbackAssignments,
  getAssignmentStatus };
